import { Card } from '@mui/material';
import { ExternalLinkInfo } from '../../models/APIModels';
import React from 'react';
import { ExternalLinkType } from '../../enums';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import XIcon from '@mui/icons-material/X';

type Props = {
  officialLink: ExternalLinkInfo;
};

export default function OfficialLinkCard({ officialLink }: Props) {
  return (
    <Card className={`official-link-item`} sx={{  width: '330px', background:`${officialLink.linkType === "Official" ? "#0288d1" :""}`, color:`${officialLink.linkType === "Official" ? "#fff" :""}` }} >
      <h5>
        {officialLink.linkType === ExternalLinkType.LinkedIn && <LinkedInIcon color="primary" />}
        {officialLink.linkType === ExternalLinkType.Facebook && <FacebookIcon color="primary" />}
        {officialLink.linkType === ExternalLinkType.Twitter && <XIcon />}
        {officialLink.linkType === ExternalLinkType.YouTube && <YouTubeIcon color="error" />}

        {officialLink.linkType}
      </h5>
      <p
        className="official-link-url"
        onClick={() => {
          window.open(officialLink.url, '_blank');
        }}
      >
        {officialLink.url}
      </p>
    </Card>
  );
}
